
var dellDialog = {
    ele: null,
    options:{
        closeOnClickMask: true, //是否可通过点击遮罩关闭
    },
    init: function(ele, options){
        if (options){
            $.extend(this.options, options);
            console.log(this.options);
        }
        if (this.ele != ele){
            this.ele = ele;
            $(ele).show();
            $('.dell-dialog .dialog-content').html('');
            $('.dell-dialog .dialog-content').append($(ele));
        }
    },
    show:function(){
        if (this.ele){
            setScroll.unScroll();
            $('.dell-dialog').show();
            $('.dell-dialog .mask').removeClass('dialog-mask-ani-fade-out').addClass('dialog-mask-ani-fade-in');
            $('.dell-dialog .dialog-content').removeClass('dialog-ani-to-top').addClass('dialog-ani-from-top');
        }else{
            this.ele = null;
            $('.dell-dialog .dialog-content').html('');
        }
    },

    closeByClickMask: function(){
        if (this.options.closeOnClickMask){
            this.close();
        }
    },

    close: function(){
        setScroll.removeUnScroll();
        $('.dell-dialog .mask').removeClass('dialog-mask-ani-fade-in').addClass('dialog-mask-ani-fade-out');
        $('.dell-dialog .dialog-content').removeClass('dialog-ani-from-top').addClass('dialog-ani-to-top');
        setTimeout(function () {
            $('.dell-dialog').hide();
        },200)
    },
}